import HeaderBar from "../../../components/header/headerBar";
import React, { useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import {
  Table,
  Button,
  Select,
  Row,
  Col,
  Input,
  DatePicker,
  Form,
  Space,
  message,
} from "antd";
import axios from "axios";
import moment from "moment";
import { Icon } from "@iconify/react";
import ModalTreatments from "../detail/doctor/modalTreatments";
import { useSelector, useDispatch } from "react-redux";

interface ParamsType {
  id: string;
  type: string;
}

const NewMedicalRecord = () => {
  let xMem = "";

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  let query = useQuery();

  const getQueryString = async () => {
    console.log("idmember =>>>>>", query.get("idmember"));
    const idmember = query.get("idmember");
    setIdMember(idmember);
  };
  const { id, type } = useParams<ParamsType>();
  let [formMedicalRecord] = Form.useForm();
  const { TextArea } = Input;
  const navigate = useHistory();
  const user = useSelector((state: any) => state.user);
  const permission = user?.permission;
  const dateFormat = "DD-MM-YYYY";

  const [comMentDoctor, setCommentDoctor] = useState<string>("");
  const [dataList, setDataList] = useState<any>([]);
  const [listTreatment, setListTreatment] = useState<any>([]);
  const [isSaved, setIsSaved] = useState<boolean>(false);
  const [xid, setXid] = useState<any>("");
  const [idMember, setIdMember] = useState<any>("");

  const columns = [
    {
      title: "",
      dataIndex: "index",
      colSpan: 1,
      key: "key",
      render: (record: any, item: any, index: number) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      colSpan: 1,
      width: "70%",
      key: "key",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      colSpan: 1,
      width: "10%",
      align: "center" as const,
      key: 4,
      render: (record: any, item: any, index: number) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            onClick={() => reduceQuantity(index)}
            style={{ cursor: "pointer" }}
          >
            <Icon
              icon="ant-design:caret-left-outlined"
              width="14"
              height="14"
            />
          </div>
          <Col>{item.quantity}</Col>
          <div onClick={() => addQuantity(index)} style={{ cursor: "pointer" }}>
            <Icon
              icon="ant-design:caret-right-outlined"
              width="14"
              height="14"
            />
          </div>
        </div>
      ),
    },
    {
      title: "Unit",
      dataIndex: "treatmentUnit",

      width: "10%",
      align: "center" as const,
      key: "key",
      span: 1,
    },
    {
      width: "10%",
      align: "center" as const,
      key: "key",
      render: (data: any) => (
        <div>
          {permission.name === "CS" ? (
            <Icon
              icon="ant-design:minus-circle-filled"
              width="1.2rem"
              height="1.2rem"
              style={{ color: "#E76464" }}
              onClick={() => deleteTreatment(data)}
            />
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const columnsOther = [
    {
      title: "",
      width: "5%",
      dataIndex: "index",
      colSpan: 1,
      key: "key",
      render: (record: any, item: any, index: number) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      colSpan: 1,
      width: "70%",
      key: "key",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      colSpan: 1,
      width: "10%",
      align: "center" as const,
      key: 4,
      render: (record: any, item: any, index: number) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Col>{item.quantity}</Col>
        </div>
      ),
    },
    {
      title: "Unit",
      dataIndex: "treatmentUnit",

      width: "10%",
      align: "center" as const,
      key: "key",
      span: 1,
    },
  ];

  const onSubmit = (values: any) => {
    console.log("values =>", values);
    console.log("dataList =>", dataList);

    if (dataList?.length === 0) {
      message.error("กรุณาเลือกรายการ Please Add Recommended Treatment");
      return;
    }

    if (type === "create") {
      const xDataList1 = [];

      for (let i = 0; i < dataList?.length; i++) {
        xDataList1.push({
          treatment: dataList[i]?._id,
          quantity: dataList[i]?.quantity,
        });
      }

      console.log("xdatalist", xDataList1);
      try {
        axios
          .post(`/medical-records?memberId=${id}`, {
            date: values?.date.utcOffset(0, true),
            topic: values?.topic,
            opinion: values?.opinion,
            recommendedTreatments: xDataList1,
          })
          .then((res) => {
            // console.log("res", res?.data?._id);
            setXid(res?.data?._id);
          });
        message.success("บันทึกสำเร็จ Save Success");
        setIsSaved(true);
      } catch (error) {
        message.error("เกิดข้อผิดพลาด Please Check Again");
      }
    } else if (type === "edit") {
      const xDataList1 = [];

      for (let i = 0; i < dataList?.length; i++) {
        xDataList1.push({
          treatment: dataList[i]?._id
            ? dataList[i]?._id
            : dataList[i]?.treatment,
          quantity: dataList[i]?.quantity,
        });
      }

      console.log("xdatalist", xDataList1);

      try {
        axios
          .patch(`/medical-records/${id}`, {
            date: values?.date.utcOffset(0, true),
            topic: values?.topic,
            opinion: values?.opinion,
            recommendedTreatments: xDataList1,
          })
          .then((res) => {
            console.log("res", res?.data?._id);
            setXid(res?.data?._id);
          });
        message.success("บันทึกสำเร็จ Save Success");
        setIsSaved(true);
      } catch (error) {
        message.error("เกิดข้อผิดพลาด Please Check Again");
      }
    }
  };
  const deleteTreatment = (values: any) => {
    console.log("values", values);

    // console.log("values Delete", values._id);

    // console.log("dataLIist Delete", dataList);
    if (type === "create") {
      const xdelete = dataList.filter(
        (x: any, i: number) => x._id !== values._id
      );
      setDataList(xdelete);
    } else if (type === "edit") {
      const xdelete = dataList.filter(
        (x: any, i: number) => x.treatment !== values.treatment
      );
      setDataList(xdelete);
    }
  };
  const setTreatment = (values: any) => {
    // console.log("values v2 1 =>", values);

    console.log("check dataList =>", dataList);

    let x_add;

    const items = dataList.map((x: any) => ({ ...x, quantitynum: 1 }));

    if (type === "create") {
      x_add = dataList.find((x: any, i: number) => x._id === values._id);
    } else if (type === "edit") {
      x_add = dataList.find(
        (x: any, i: number) =>
          x.treatment === values._id || x._id === values._id
      );
    }

    console.log("x_add", x_add);
    if (x_add === undefined) {
      items.push(values);
      // console.log("datalist=>>>>", items);
      const newItems = items.map((data: any, index: number) => ({
        ...data,
        index: index + 1,
      }));
      console.log("newItems", newItems);

      setDataList(newItems);
    } else {
      message.error("เลือกซ้ำ / You Have Already Items");
      return;
    }
  };
  const getDataHead = async () => {
    if (type === "create") {
      axios
        .get(`/medical-records/get-member-info?memberId=${id}`)
        .then((res) => {
          const xData = res?.data;
          console.log("xdata", xData);

          formMedicalRecord.setFieldsValue({
            code: xData.code,
            customer: xData.customer,
            cn: xData.customerCode,
            doctor: xData.doctor,
            date: moment(),
            underlyingDisease: xData.underlyingDisease,
            allergyHistory: xData.allergyHistory,
          });
        });
    } else if (type === "edit") {
      axios.get(`/medical-records/${id}`).then((res) => {
        const xData = res?.data;
        console.log("xdata update", xData);

        formMedicalRecord.setFieldsValue({
          customer: xData.customer,
          cn: xData.customerCode,
          doctor: xData.doctor,
          date: moment(xData.date),
          underlyingDisease: xData.underlyingDisease,
          allergyHistory: xData.allergyHistory,
          topic: xData.topic,
          opinion: xData.opinion,
        });
        setDataList(xData.recommendedTreatments);
      });
    }
  };

  const addQuantity = (index: any) => {
    console.log("dataList add", dataList);
    console.log("index", index);

    let newValue = [...dataList];
    newValue[index].quantity = newValue[index].quantity + 1;
    // newValue[index].total = newValue[index].price * newValue[index].quantity;
    setDataList(newValue);
    // isTotalBom();
  };

  const reduceQuantity = (index: any) => {
    let newValue = [...dataList];
    if (newValue[index].quantity > 1) {
      newValue[index].quantity = newValue[index].quantity - 1;
      // newValue[index].total = newValue[index].price * newValue[index].quantity;
      setDataList(newValue);
      // isTotalBom();
    }
  };
  useEffect(() => {
    getDataHead();
    getQueryString();
    console.log("type=>>>", type);
  }, []);

  useEffect(() => {
    console.log("dataList", dataList);
  }, [dataList]);

  return (
    <div>
      <Form form={formMedicalRecord} onFinish={onSubmit}>
        <HeaderBar
          btnBack={true}
          title={
            type === "create"
              ? "Create Medical Record"
              : "Update Medical Record"
          }
        />
        <div
          style={{ padding: "20px", margin: "10px 40px" }}
          className="create-page create-dr"
        >
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <div className="heading">
                <p>Customer</p>
              </div>
              <Form.Item name="customer">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>CN</p>
              </div>
              <Form.Item name="cn">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>Doctor</p>
              </div>
              <Form.Item name="doctor">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>DATE</p>
              </div>
              <Form.Item name="date">
                <DatePicker
                  inputReadOnly
                  disabled
                  format={dateFormat}
                  style={{
                    height: "auto",
                    width: "100%",
                    border: "none",
                    borderRadius: "0px",
                    borderBottom: "1px solid #d9d9d9",
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col span={6}>
              <div className="heading">
                <p>โรคประจำตัว (Underlying Disease)</p>
              </div>
              <Form.Item name="underlyingDisease">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>แพ้ยา (Allergy History)</p>
              </div>
              <Form.Item name="allergyHistory">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <br />
              <Form.Item
                name="topic"
                rules={[
                  {
                    required: true,
                    message: "Please Input!",
                  },
                ]}
              >
                <Input
                  placeholder="เรื่องที่ปรึกษา/Subject"
                  disabled={permission.name === "CS" ? false : true}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ marginTop: "20px" }}>
            <Col span={24} className="textArea-custom">
              <h5>Doctor Opinion</h5>
              <Form.Item
                name="opinion"
                rules={[
                  {
                    required: true,
                    message: "Please Input!",
                  },
                ]}
              >
                <TextArea
                  placeholder="ความเห็นแพทย์"
                  style={{ height: "400px" }}
                  disabled={permission.name === "CS" ? false : true}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <div className="recommended-treatment" style={{ margin: "10px 40px" }}>
          <Row>
            <Col span={12} style={{ alignSelf: "center" }}>
              <h5>Recommended Treatment</h5>
            </Col>
            <Col span={12}>
              {permission.name === "CS" && (
                <ModalTreatments dataTreatment={setTreatment} />
              )}
            </Col>
          </Row>

          <div style={{ marginTop: "20px" }} className="table-data">
            <Form.Item name="recommendedTreatments">
              <Table
                columns={permission.name === "CS" ? columns : columnsOther}
                dataSource={dataList}
                bordered
                scroll={{ x: 100 }}
                rowKey={"_id"}
              />
            </Form.Item>
          </div>
        </div>

        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 35 }}
        >
          {permission.name === "CS" && (
            <Space>
              {isSaved ? (
                <Button
                  // onClick={() => {
                  //   setIsOpen(false);
                  // }}
                  onClick={() =>
                    setTimeout(() => {
                      navigate.push(
                        type === "create"
                          ? `/opd/print/${id}?memberId=${id}&medicalRecordId=${xid}&type=Doctor`
                          : `/opd/print/${idMember}?memberId=${idMember}&medicalRecordId=${xid}&type=Doctor`
                      );
                    }, 500)
                  }
                  style={{
                    width: "100%",
                    height: 50,
                    background: "#4285F4",
                    borderRadius: 4,
                    color: "white",
                  }}
                  // prefix={<Icon></Icon>}
                >
                  <Icon
                    icon="ps:printer"
                    width="1.2rem"
                    height="1.2rem"
                    style={{ marginRight: "8px", marginBottom: " 4px" }}
                  />
                  Print OPD
                </Button>
              ) : (
                <Button
                  htmlType="submit"
                  style={{
                    width: "100%",
                    height: 50,
                    background: "#4D7E7F",
                    borderRadius: 4,
                    color: "white",
                  }}
                >
                  บันทึกข้อมูล/Submit
                </Button>
              )}
            </Space>
          )}
        </div>
      </Form>
    </div>
  );
};
export default NewMedicalRecord;
